import { gql } from "apollo-boost";

const AGENT_QUERY = gql`
  query agentQuery {
    viewer {
      email
      industry_professional {
        industry_professional_share_tokens {
          listing_provider_id
          token
        }
      }
    }
  }
`;

export default AGENT_QUERY;
